import { type FetchResult, gql, useMutation } from "@apollo/client";

import { ADD_NODE } from "./../../../common/operations/mutations";
import type {
  AddNodeMutation,
  AddNodeMutationVariables,
  AddNodeInput,
} from "./../../../API";

type Data<T> = T | null | undefined;

interface CreateNodeInterface {
  createNode: (input: AddNodeInput) => Promise<FetchResult<AddNodeMutation>>;
  data?: AddNodeMutation | null;
  loading: boolean;
}

export const useCreateNode = (): CreateNodeInterface => {
  const [saveNode, { data, loading }] = useMutation<
    AddNodeMutation,
    AddNodeMutationVariables
  >(ADD_NODE);

  const createNode = async (
    input: AddNodeInput
  ): Promise<FetchResult<AddNodeMutation>> => {
    return await saveNode({
      variables: {
        input,
      },
      update(cache, response): void {
        cache.modify({
          fields: {
            getNodesByCustomer(existing): Data<AddNodeMutation> {
              const newNodeRef = cache.writeFragment({
                data: response.data?.addNode,
                fragment: gql`
                  fragment NewNode on Node {
                    customerId
                    deviceData
                    id
                    level
                    locationId
                    nodeName
                    nodeId
                    onboardCommand
                    serviceData
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, newNodeRef],
              };
            },
          },
        });
      },
    });
  };

  return { createNode, data, loading };
};
